import * as React from 'react';

import { useDispatch } from 'react-redux'
import { setOperation } from '../operation/operationSlice';

import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick}>
                <DataColumn kid='column1' name='Ruolo' fieldName='name' minWidth={250} align='left' />
                <DataColumn kid='column2' name='Inizio Validit&agrave;' fieldName='start_date' minWidth={280} maxWidth={280} align='center' />
                <DataColumn kid='column3' name='Fine Validit&agrave;' fieldName='end_date' minWidth={280} maxWidth={280} align='center' />
            </DataList>
        </>
    );
}
